import PropTypes from 'prop-types';
export default (obj => PropTypes.oneOf(Object.values(obj)));